<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">
          {{ createOrUpdate }} <span v-if="poNumber">P.O # {{ poNumber }}</span>
        </h4>
        &nbsp;
      </div>
      <div class="level-right">
        <input
          type="text"
          class="input is-small"
          style="text-align: right"
          placeholder="AUTOGENERATED P.O #"
          v-model="poNumber"
          disabled
        />
        &nbsp;
        <button
          v-if="purchaseOrder.purchaseOrderId"
          :class="buttonDownloadPoRequest"
          title="Download PDF"
          @click="
            downloadPdf(purchaseOrder.purchaseOrderId, purchaseOrder.poNum)
          "
        >
          <span class="icon">
            <i class="far fa-file-pdf"></i>
          </span>
        </button>
        &nbsp;
        <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
        <!-- &nbsp;
        <button :class="buttonSave" @click="saveAndSend(true)">
          Save & send
        </button> -->
        &nbsp;
        <router-link
          :to="{
            name: 'List of Purchase Order',
            params: { pageSize: 10 },
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Supplier</label>
          <div class="control">
            <b-autocomplete
              id="searchSupplier"
              v-model="supplierName"
              size="is-small"
              :data="suppliers"
              placeholder="Search suppliers"
              @select="(option) => (selectedSupplier = option)"
              @input="searchSuppliers"
              :loading="isFetchingSuppliers"
            >
              <template slot="empty">
                <span v-if="isFetchingSuppliers">Please wait...</span>
                <span v-if="suppliers.length === 0">No results found</span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">Email (Separate with a comma)</label>
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="purchaseOrder.emails"
              placeholder="Enter email(s) here"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Status</label>
          <div class="select is-small">
            <select v-model="purchaseOrder.poStatus">
              <option value="0">OPEN</option>
              <option value="1">CLOSED</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Mailing address</label>
          <textarea
            style="height: 50px"
            type="text"
            class="input is-small"
            v-model="purchaseOrder.mailingAddress"
            placeholder="Enter mailing address"
          />
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Shipping address</label>
          <textarea
            style="height: 50px"
            type="text"
            class="input is-small"
            v-model="purchaseOrder.shippingAddress"
            placeholder="Enter shipping address"
          />
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">P.O date</label>
          <div class="control">
            <input
              type="date"
              class="input is-small"
              v-model="purchaseOrder.poDate"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">Product/Service</label>
          <div class="control">
            <b-autocomplete
              id="searchProductOrService"
              v-model="productOrServiceName"
              size="is-small"
              :data="productsOrServices"
              placeholder="Search product/service"
              @select="(option) => (selectedProductOrService = option)"
              @input="searchProductsOrServices"
              :loading="isFetchingProductOrServices"
            >
              <template slot="empty">
                <span v-if="isFetchingProductOrServices">Please wait...</span>
                <span v-if="productsOrServices.length === 0"
                  ><button
                    class="button is-info is-small"
                    @click="addNewProductOrService"
                  >
                    Add new
                  </button></span
                >
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Sku</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              placeholder="sku"
              v-model="purchaseOrderForTable.sku"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Desc.</label>
          <div class="control">
            <textarea
              style="height: 50px"
              type="text"
              class="input is-small"
              placeholder="Enter desc."
              v-model="purchaseOrderForTable.desc"
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Qty</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              placeholder="0"
              v-model="purchaseOrderForTable.qty"
              @keyup="quantityOrRateKeyUp"
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Rate</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              placeholder="0"
              v-model="purchaseOrderForTable.rate"
              @keyup="quantityOrRateKeyUp"
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Amount</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              placeholder="0"
              v-model="purchaseOrderForTable.amount"
            />
          </div>
        </div>
      </div>
      <!-- <div class="column is-1">
        <div class="field">
          <label class="label is-small">Tax</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              placeholder="0"
              v-model="purchaseOrderForTable.tax"
            />
          </div>
        </div>
      </div> -->
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Client</label>
          <div class="control">
            <b-autocomplete
              v-model="clientName"
              size="is-small"
              :data="clients"
              placeholder="Search clients"
              @select="(option) => (selectedClient = option)"
              @input="searchClients"
              name="Client"
              :loading="isFetchingClients"
            >
              <template slot="empty">
                <span v-if="isFetchingClients">Please wait...</span>
                <span v-if="clients.length === 0">No results found</span>
              </template>
            </b-autocomplete>
            <span style="font-size: 12px" class="has-text-danger">{{
              errors.first("Client")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="field">
          <div class="control">
            <button
              id="addSubDetail"
              class="button is-small is-info"
              @click="addOrEditToPoDetail"
            >
              {{ addOrEditToTable }}
            </button>
            &nbsp;
            <button
              class="button is-small"
              v-if="addOrEditToTable === 'Update'"
              @click="cancelSelectedPoDetail"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-table
      :data="purchaseOrder.purchaseOrderDetails"
      :loading="isLoadingTable"
    >
      <template slot-scope="item">
        <b-table-column
          class="table-column-content-is-small"
          label="PRODUCT/SERVICE"
          >{{ item.row.productOrServiceName }}</b-table-column
        >
        <b-table-column class="table-column-content-is-small" label="SKU">{{
          item.row.sku
        }}</b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="DESCRIPTION"
          >{{ item.row.desc }}</b-table-column
        >
        <b-table-column class="table-column-content-is-small" label="QTY">{{
          item.row.qty
        }}</b-table-column>
        <b-table-column class="table-column-content-is-small" label="RATE">{{
          item.row.rate | formatNumber
        }}</b-table-column>
        <b-table-column class="table-column-content-is-small" label="AMOUNT">{{
          item.row.amount | formatNumber
        }}</b-table-column>
        <!-- <b-table-column class="table-column-content-is-small" label="TAX">{{
          item.row.tax
        }}</b-table-column> -->
        <b-table-column class="table-column-content-is-small" label="CLIENT">{{
          item.row.client
        }}</b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            class="button is-warning is-small"
            @click="selectForEdit(item.row)"
          >
            Edit
          </button>
          &nbsp;
          <button
            :class="buttonDelete"
            @click="
              confirmRemoveDetail(
                item.row.purchaseOrderDetailId
                  ? item.row.purchaseOrderDetailId
                  : item.row.tempId
              )
            "
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </b-table>
    <div class="notification">
      <loading
        :active.sync="isLoadingTotal"
        color="#3BAFDA"
        :can-cancel="false"
        :is-full-page="isFullPage"
      ></loading>
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="field">
            <div class="control">
              <label class="label is-small">Total</label>
              <div class="control">
                <h4 class="title is-4">{{ this.poTotal.total }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
        <!-- &nbsp;
        <button :class="buttonSave" @click="saveAndSend(true)">
          Save & send
        </button> -->
        &nbsp;
        <router-link
          :to="{
            name: 'List of Purchase Order',
            params: { pageSize: 10 },
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <CreateProductOrService />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import axios from "axios";
import moment from "moment";
import numeral from "numeral";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import _ from "lodash";
import CreateProductOrService from "./../ProductOrService/CreateEdit";

Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  components: {
    Loading,
    CreateProductOrService,
  },
  computed: {
    ...mapState("productorservice", {
      productOrServiceState: (state) => state.productOrServiceState,
    }),
  },
  data: () => ({
    isFetchingSavedInfo: false,
    poTotal: {
      subTotal: 0,
      total: 0,
    },
    poNumber: "",
    createOrUpdate: "Create ",
    addOrEditToTable: "Add",
    purchaseOrder: {
      purchaseOrderId: 0,
      poNum: 0,
      supplierId: 0,
      emails: "",
      cc: "",
      bcc: "",
      poStatus: 0,
      mailingAddress: "",
      shipTo: "",
      shippingAddress: "",
      shipVia: "",
      poDate: null,
      cvNo: "",
      checkNo: "",
      oldPoNum: "",
      messageToSupplier: "",
      purchaseOrderDetails: [],
    },
    purchaseOrderForTable: {
      id: 0,
      productOrServiceName: "",
      sku: "",
      desc: "",
      qty: 0,
      rate: 0,
      amount: 0,
      tax: 0,
      clientId: 0,
      client: "",
    },
    // search supplier
    supplierName: "",
    suppliers: [],
    selectedSupplier: 0,
    selectedSupplierForEdit: {},
    isFetchingSuppliers: false,
    // search clients
    clientName: "",
    clients: [],
    selectedClient: 0,
    selectedClientForEdit: {},
    isFetchingClients: false,
    // search products or services
    productOrServiceName: "",
    productsOrServices: [],
    selectedProductOrService: 0,
    selectedProductOrServiceForEdit: {},
    isFetchingProductOrServices: false,
    // loadings
    isLoadingTable: false,
    isLoadingTotal: false,
    isFullPage: false,
    // buttons
    buttonDelete: appButton.isLoadingDanger(false),
    buttonSave: appButton.isLoadingSuccess(false),
    buttonSaveAndSend: appButton.isLoadingSuccess(false),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false),
  }),
  created() {
    const purchaseOrderId = this.$route.params.purchaseOrderId;
    if (purchaseOrderId) {
      this.getPoById(purchaseOrderId);
    } else {
      // CREATE Mode
      this.purchaseOrder.shippingAddress =
        "Any Network Systems, Inc. 300 JP Rizal St. Makati City 1204 PH";
      this.getCurrentDateFromServer();
    }
  },
  methods: {
    ...mapActions("productorservice", [
      "openCreateEditModal",
      "clearSelectedPurchaseOrderState",
    ]),
    goBack() {
      this.$router.go(-1);
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then((response) => {
          this.purchaseOrder.poDate = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    getPoById(id) {
      this.isFetchingSavedInfo = true;
      this.createOrUpdate = "Edit";
      axios
        .get(`api/purchaseorders/${id}`)
        .then((response) => {
          this.purchaseOrder = response.data;
          this.purchaseOrder.poDate = moment(this.purchaseOrder.poDate).format(
            "YYYY-MM-DD"
          );
          this.supplierName = this.purchaseOrder.supplier;
          this.supplierId = this.purchaseOrder.supplierId;
          this.poNumber = this.purchaseOrder.poNum;
          this.calculateTotalPo(id);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    quantityOrRateKeyUp() {
      this.purchaseOrderForTable.amount =
        Number(this.purchaseOrderForTable.qty) *
        Number(this.purchaseOrderForTable.rate);
    },
    calculateTotalPo() {
      this.isLoadingTotal = true;
      let qtyAndRate = [];
      this.purchaseOrder.purchaseOrderDetails.forEach((d) => {
        qtyAndRate = [
          ...qtyAndRate,
          {
            qty: d.qty,
            rate: d.rate,
          },
        ];
      });
      const toCalculateTotalPo = {
        details: qtyAndRate,
      };
      axios
        .post(`api/purchaseorders/calculate-total-po`, toCalculateTotalPo)
        .then((response) => {
          this.poTotal.subTotal = numeral(response.data.subTotal).format(
            "0,0.0"
          );
          this.poTotal.total = numeral(response.data.total).format("0,0.0");
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            appToast.danger(error.response.data);
          }
        })
        .then(() => {
          setTimeout(() => {
            this.isLoadingTotal = false;
          }, 500);
        });
    },
    addNewProductOrService() {
      this.openCreateEditModal({
        showCreateOrEditModal: true,
        productOrServiceState: {
          isSaveAndUse: true,
        },
      });
    },
    downloadPdf(id, poNumber) {
      if (id) {
        this.buttonDownloadPoRequest = appButton.isLoadingDefault(true);
        axios
          .get(`downloadables/purchaseorder?id=${id}`, {
            responseType: "blob",
          })
          .then((response) => {
            console.log(response.data);
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `PURCHASE ORDER ${poNumber}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadPoRequest = appButton.isLoadingDefault(false))
          );
      }
    },
    saveAndSend(isSend) {
      if (!this.purchaseOrder.supplierId) {
        appToast.danger("Supplier is empty.");
        return false;
      }

      if (!this.purchaseOrder.poDate) {
        appToast.danger("P.O. date is empty.");
        return false;
      }

      if (this.poTotal.total < 0) {
        appToast.danger("Total must be greater than or equal to 0.");
        return false;
      }

      if (this.purchaseOrder.purchaseOrderDetails.length === 0) {
        appToast.danger("P.O Detail is empty.");
        return false;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true);
          const purchaseOrderId = this.$route.params.purchaseOrderId;
          if (!purchaseOrderId) {
            // CREATE
            axios
              .post(`api/purchaseorders/`, this.purchaseOrder)
              .then((response) => {
                appToast.success(response.data.message);
                if (isSend) {
                  //this.sendPoRequest(response.data.id);
                }
                this.getPoById(response.data.id);
                this.$router.push({
                  name: "Edit Purchase Order",
                  params: { purchaseOrderId: response.data.id },
                });
              })
              .catch((error) => {
                console.log(error);
                appToast.danger(error.response.data);
              })
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false);
              });
          } else {
            // EDIT
            axios
              .put(`api/purchaseorders/${purchaseOrderId}`, this.purchaseOrder)
              .then((response) => {
                if (isSend) {
                }
                this.$router.push({
                  name: "List of Purchase Order",
                  params: { pageSize: 10 },
                });
                appToast.success(response.data);
                this.getPoById(purchaseOrderId);
              })
              .catch((error) => {
                appToast.danger(error.response.data);
                console.log(error);
              })
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false);
              });
          }
        }
      });
    },
    searchProductsOrServices() {
      // authService.isLoggedIn() // check login
      axios
        .get(
          `api/searchqueries/products-or-services-by-name/${this.productOrServiceName}`
        )
        .then((response) => {
          this.productsOrServices = response.data;
        })
        .catch((error) => console.log(error));
    },
    searchSuppliers() {
      // authService.isLoggedIn() // check login
      axios
        .get(`api/searchqueries/suppliers-by-name/${this.supplierName}`)
        .then((response) => {
          this.suppliers = response.data;
        })
        .catch((error) => console.log(error));
    },
    searchClients() {
      //authService.isLoggedIn() // check login
      if (this.clientName) {
        axios
          .get(`api/searchqueries/clients-by-name/${this.clientName}/true`)
          .then((response) => {
            this.clients = response.data;
          })
          .catch((error) => {
            console.log(error.response.status);
          });
      }
    },
    // table detail section
    addOrEditToPoDetail() {
      if (this.productOrServiceState.productOrServiceName) {
        this.purchaseOrderForTable.productOrServiceName = this.productOrServiceState.productOrServiceName;
      }

      if (!this.purchaseOrderForTable.productOrServiceName) {
        appToast.danger("Product/Service is empty. Please select a valid one.");
        return false;
      }
      this.isLoadingTable = true;
      // UPDATE MODE
      if (this.addOrEditToTable === "Update") {
        let index = null;
        let isUsingTempId = false;
        const idTypeOf = typeof this.purchaseOrderForTable.id; // check if it's temp id
        if (idTypeOf === "string") {
          index = _.findIndex(this.purchaseOrder.purchaseOrderDetails, {
            tempId: this.purchaseOrderForTable.id,
          });

          isUsingTempId = true;
        } else {
          index = _.findIndex(this.purchaseOrder.purchaseOrderDetails, {
            purchaseOrderDetailId: this.purchaseOrderForTable.id,
          });
        }

        // check if the existing client is the same from the selected data from the table
        let selectedClientIsNotEqual = false;
        if (this.selectedClient) {
          if (this.selectedClientForEdit.id != this.selectedClient.id) {
            selectedClientIsNotEqual = true;
          }
        }

        const client = selectedClientIsNotEqual
          ? this.selectedClient.value
          : this.selectedClientForEdit.value;

        const clientId = selectedClientIsNotEqual
          ? this.selectedClient.id
          : this.selectedClientForEdit.id;

        if (!clientId) {
          appToast.danger("Client is empty. Please select a valid one.");
          this.isLoadingTable = false;
          return false;
        }

        if (isUsingTempId) {
          // if using tempid, supply the tempId property if not, supply the primary key
          this.purchaseOrder.purchaseOrderDetails.splice(index, 1, {
            productOrServiceName: this.purchaseOrderForTable
              .productOrServiceName,
            sku: this.purchaseOrderForTable.sku,
            desc: this.purchaseOrderForTable.desc,
            qty: this.checkIfValIsValidNumber(this.purchaseOrderForTable.qty),
            rate: this.checkIfValIsValidNumber(this.purchaseOrderForTable.rate),
            amount: this.checkIfValIsValidNumber(
              this.purchaseOrderForTable.amount
            ),
            tax: this.checkIfValIsValidNumber(this.purchaseOrderForTable.tax),
            client: client,
            clientId: clientId,
            productOrServiceId: this.purchaseOrderForTable.productOrServiceId,
            tempId: this.purchaseOrderForTable.id,
          });
        } else {
          this.purchaseOrder.purchaseOrderDetails.splice(index, 1, {
            productOrServiceName: this.purchaseOrderForTable
              .productOrServiceName,
            sku: this.purchaseOrderForTable.sku,
            desc: this.purchaseOrderForTable.desc,
            qty: this.checkIfValIsValidNumber(this.purchaseOrderForTable.qty),
            rate: this.checkIfValIsValidNumber(this.purchaseOrderForTable.rate),
            amount: this.checkIfValIsValidNumber(
              this.purchaseOrderForTable.amount
            ),
            tax: this.checkIfValIsValidNumber(this.purchaseOrderForTable.tax),
            client: client,
            clientId: clientId,
            productOrServiceId: this.purchaseOrderForTable.productOrServiceId,
            purchaseOrderDetailId: this.purchaseOrderForTable.id,
          });
        }
      } else {
        // ADD MODE
        console.log(!this.selectedClient.id);
        if (!this.selectedClient.id || !this.purchaseOrderForTable.clientId) {
          appToast.danger("Client is empty. Please select a valid one.");
          this.isLoadingTable = false;
          return false;
        }

        this.purchaseOrder.purchaseOrderDetails = [
          ...this.purchaseOrder.purchaseOrderDetails,
          {
            productOrServiceName: this.purchaseOrderForTable
              .productOrServiceName,
            sku: this.purchaseOrderForTable.sku,
            desc: this.purchaseOrderForTable.desc,
            qty: this.checkIfValIsValidNumber(this.purchaseOrderForTable.qty),
            rate: this.checkIfValIsValidNumber(this.purchaseOrderForTable.rate),
            amount: this.checkIfValIsValidNumber(
              this.purchaseOrderForTable.amount
            ),
            tax: this.checkIfValIsValidNumber(this.purchaseOrderForTable.tax),
            clientId: this.selectedClient.id,
            client: this.selectedClient.value,
            productOrServiceId: this.purchaseOrderForTable.productOrServiceId,
            tempId: `t${new Date().getTime()}`,
          },
        ];
      }
      this.defaultPurchaseOrderForTable();
      this.isLoadingTable = false;
      this.calculateTotalPo();
    },
    checkIfValIsValidNumber(number) {
      return !number ? 0 : number;
    },
    cancelSelectedPoDetail() {
      this.defaultPurchaseOrderForTable();
    },
    selectForEdit(row) {
      this.addOrEditToTable = "Update";
      this.purchaseOrderForTable.productOrServiceName =
        row.productOrServiceName;
      this.purchaseOrderForTable.productOrServiceId = row.productOrServiceId;
      this.purchaseOrderForTable.sku = row.sku;
      this.purchaseOrderForTable.desc = row.desc;
      this.purchaseOrderForTable.qty = row.qty;
      this.purchaseOrderForTable.rate = row.rate;
      this.purchaseOrderForTable.amount = row.amount;
      this.purchaseOrderForTable.tax = row.tax;

      // product or service
      this.productOrServiceName = row.productOrServiceName;
      this.selectedProductOrServiceForEdit.id = row.productOrServiceId;
      this.selectedProductOrServiceForEdit.value = row.productOrServiceName;
      // client
      this.clientName = row.client;
      this.selectedClientForEdit.id = row.clientId;
      this.selectedClientForEdit.value = row.client;

      // check if the id temporary or from saved item
      let tableId = 0;
      row.tempId
        ? (tableId = row.tempId)
        : (tableId = row.purchaseOrderDetailId);

      this.purchaseOrderForTable.id = tableId;
    },
    confirmRemoveDetail(id) {
      const confirm = window.confirm(
        "Are you sure do you want to remove this detail?"
      );
      if (confirm) {
        this.removeFromTable(id);
      }
    },
    removeFromTable(id) {
      this.isLoadingTable = true;
      this.buttonDelete = appButton.isLoadingDanger(true);
      console.table(this.purchaseOrder.purchaseOrderDetails);
      // check if id is temp or with t
      const idTypeOf = typeof id;
      if (idTypeOf === "string") {
        // check if id is string, if it is string, remove from the array, if not, remove from the database
        const hasT = id.charAt(0);
        if (hasT === "t") {
          _.remove(this.purchaseOrder.purchaseOrderDetails, { tempId: id }); // Create module
        }
      } else {
        // delete if the id is from saved info
        _.remove(this.purchaseOrder.purchaseOrderDetails, {
          purchaseOrderDetailId: id,
        });
      }
      this.isLoadingTable = false;
      this.buttonDelete = appButton.isLoadingDanger(false);
      this.calculateTotalPo();
    },
    defaultPurchaseOrderForTable() {
      this.purchaseOrderForTable = {
        id: `t${new Date().getTime()}`,
        productOrServiceName: "",
        productOrServiceId: 0,
        sku: "",
        desc: "",
        qty: 0,
        rate: 0,
        amount: 0,
        tax: 0,
        clientId: 0,
        client: "",
      };

      this.addOrEditToTable = "Add";
      this.clientName = "";
      this.clients = [];
      this.selectedClient = 0;
      this.isFetchingClients = false;

      this.productOrServiceName = "";
      this.productsOrServices = [];
      this.selectedProductOrService = 0;
      this.isFetchingProductOrServices = false;

      this.clearSelectedPurchaseOrderState({
        isClear: true,
      });
    },
  },
  watch: {
    productOrServiceState() {
      const data = this.productOrServiceState;

      if (data) {
        if (data.productOrServiceId) {
          this.purchaseOrderForTable.productOrServiceId =
            data.productOrServiceId;
          this.purchaseOrderForTable.productOrServiceName =
            data.productOrServiceName;
          console.log(this.purchaseOrderForTable.productOrServiceName);
          this.productOrServiceName = data.productOrServiceName;
          this.purchaseOrderForTable.productOrServiceName = data.name;
          this.purchaseOrderForTable.qty = data.qty;
          this.purchaseOrderForTable.desc = data.desc;
          this.purchaseOrderForTable.sku = data.sku;
          this.purchaseOrderForTable.rate = data.cost;
          this.purchaseOrderForTable.tax = 0;
          if (
            this.purchaseOrderForTable.qty &&
            this.purchaseOrderForTable.rate
          ) {
            this.purchaseOrderForTable.amount =
              Number(this.purchaseOrderForTable.qty) *
              Number(this.purchaseOrderForTable.rate);
          } else {
            this.purchaseOrderForTable.amount = 0;
          }
        }
      }
    },
    selectedSupplier() {
      if (this.selectedSupplier.id) {
        this.purchaseOrder.supplierId = this.selectedSupplier.id;
      } else {
        this.selectedSupplier = 0;
      }
    },
    selectedClient() {
      if (this.selectedClient) {
        this.purchaseOrderForTable.clientId = this.selectedClient.id;
      } else {
        this.selectedClient = 0;
      }
    },
    selectedProductOrService() {
      const data = this.selectedProductOrService;
      if (data) {
        // clear first before adding new
        this.purchaseOrderForTable.productOrServiceId = 0;
        this.purchaseOrderForTable.productOrServiceName = "";
        this.purchaseOrderForTable.desc = "";
        this.purchaseOrderForTable.sku = "";
        this.purchaseOrderForTable.qty = "";
        this.purchaseOrderForTable.rate = "";
        // then assign
        this.purchaseOrderForTable.productOrServiceId = data.id;
        this.purchaseOrderForTable.productOrServiceName = data.value;
        this.purchaseOrderForTable.desc = data.description1;
        this.purchaseOrderForTable.sku = data.description2;
        this.purchaseOrderForTable.qty = Number(data.description3);
        this.purchaseOrderForTable.rate = Number(data.description4);
        if (this.purchaseOrderForTable.qty && this.purchaseOrderForTable.rate) {
          this.purchaseOrderForTable.amount =
            this.purchaseOrderForTable.qty * this.purchaseOrderForTable.rate;
        } else {
          this.purchaseOrderForTable.amount = 0;
        }
      }
    },
  },
};
</script>